import {api} from '../../App'

export const auth = (id) => {
  return api.get(`/order/${id}/kitchen`)
}
